/**
 * View Teaser block.
 * @module components/manage/Blocks/Teaser/DefaultBody.jsx
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers';
import { getTeaserImageURL } from './utils';
import { MaybeWrap } from '@plone/volto/components';
import { UniversalLink } from '@plone/volto/components';
import cx from 'classnames';
import config from '@plone/volto/registry';
import Fallbackimage from 'volto-starzel/images/fallbackimage.png';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const TeaserDefaultTemplate = (props) => {
  const { className, data, isEditMode } = props;
  const intl = useIntl();
  const href = data.href?.[0];
  const imageOverride = data.preview_image?.[0];
  const align = data?.styles?.align;

  const { openExternalLinkInNewTab } = config.settings;

  let renderedImage = null;
  if (href && (imageOverride || href.hasPreviewImage || href.image_field)) {
    let Image = config.getComponent('Image').component;
    if (Image) {
      renderedImage = (
        <Image
          item={imageOverride || href}
          alt=""
          loading="lazy"
          responsive={true}
        />
      );
    } else {
      // default img expects string src
      const src = flattenToAppURL(
        getTeaserImageURL({ href, imageOverride, align }),
      );
      renderedImage = <img src={src} alt="" loading="lazy" />;
    }
    // START CUSTOMIZATION
  } else {
    if (href?.['@type'] === 'News Item') {
      const src = Fallbackimage;
      renderedImage = <img src={src} alt="Fallbackimage" loading="lazy" />;
    }
  }
  // END CUSTOMIZATION

  return (
    <div className={cx('block teaser', className)}>
      <>
        {!href && isEditMode && (
          <Message>
            <div className="teaser-item placeholder">
              <img src={imageBlockSVG} alt="" />
              <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
            </div>
          </Message>
        )}
        {href && (
          <MaybeWrap
            condition={!isEditMode}
            as={UniversalLink}
            href={href['@id']}
            target={
              data.openLinkInNewTab ||
              (openExternalLinkInNewTab && !isInternalURL(href['@id']))
                ? '_blank'
                : null
            }
          >
            <div className="teaser-item default">
              {renderedImage && (
                <div className="image-wrapper">{renderedImage}</div>
              )}
              <div className="content">
                {data?.head_title && (
                  <div className="headline">{data.head_title}</div>
                )}
                <h2>{data?.title}</h2>
                {!data.hide_description && <p>{data?.description}</p>}
              </div>
            </div>
          </MaybeWrap>
        )}
      </>
    </div>
  );
};

TeaserDefaultTemplate.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default TeaserDefaultTemplate;
